// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"JobTitle_inputWrapper__TrrFA","errorText":"JobTitle_errorText__q2fqC"};